import { Link, useLocation } from 'react-router-dom';
import { NavbarUser } from './NavbarUser';

type NavKey = 'inbox' | 'admin';

type Props = {
  readonly inboxCount?: number;
};

export function Sidebar({ inboxCount }: Props) {
  const location = useLocation();
  const active: NavKey = location.pathname.startsWith('/admin') ? 'admin' : 'inbox';

  return (
    <aside className="sidebar">
      <div className="brand-lockup">
        <div className="brand-mark">M</div>
        <div>
          <div className="brand-name">Mindwright</div>
          <div className="brand-sub">by Moltomedia</div>
        </div>
      </div>

      <div className="nav">
        <div className="nav-section">Anforderungen</div>
        <Link to="/inbox" className={'nav-item ' + (active === 'inbox' ? 'active' : '')}>
          <InboxIcon />
          <span className="lbl">Inbox</span>
          {inboxCount !== undefined && <span className="count">{inboxCount}</span>}
        </Link>
        <div className="nav-section">Admin</div>
        <Link
          to="/admin/prompts"
          className={'nav-item ' + (active === 'admin' ? 'active' : '')}
        >
          <SparkIcon />
          <span className="lbl">Prompts</span>
        </Link>
      </div>

      <div className="side-spacer" />
      <NavbarUser />
    </aside>
  );
}

function InboxIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M22 12h-6l-2 3h-4l-2-3H2" />
      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11Z" />
    </svg>
  );
}

function SparkIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" />
    </svg>
  );
}
